import { render, staticRenderFns } from "./PurchaseStatus.vue?vue&type=template&id=8461c130"
import script from "./PurchaseStatus.vue?vue&type=script&lang=js"
export * from "./PurchaseStatus.vue?vue&type=script&lang=js"
import style0 from "./PurchaseStatus.vue?vue&type=style&index=0&id=8461c130&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports